module.exports = __webpack_public_path__ + "img/zippy-travel.bac0f14f.png";